<template>
	<el-dialog width="370px" :visible.sync="innerVisible" append-to-body custom-class="newdialog">
		<!-- 导入 -->
		<div class="innerdialog">
			<div class="innerdialog_list">
				<p>导入模板：</p>
				<a :href="imgSrc" download><span>
						下载模板
					</span></a>
			</div>
			<div class="innerdialog_list">
				<p>选择模板：</p>
				<label>{{fileName}}</label>
				<el-upload class="upload-demo" :on-success="onSuccess" :data="data" :headers="headers"
					:action="actionUrl" :on-remove="handleRemove" :file-list="fileList">
					<p class="innerspan">···</p>
				</el-upload>

			</div>
		</div>
		<div slot="footer" class="dialog-footer">
			<!-- <el-button @click="innerVisible = false">取 消</el-button> -->
			<el-button type="primary" @click="closeImport">关闭</el-button>
		</div>
	</el-dialog>
</template>

<script>
	var that = this
	export default {
		data() {
			return {
				innerVisible: false,
				imgSrc: '',
				fileList: [],
				fileName: '',
				progecode: ''
			}
		},
		computed: {
			headers: () => {
				return {
					'token': localStorage.getItem('token')
				}
			},
			data: function(){
				return {
					"project_code": this.progecode
				}
			}
		},
		created() {
			this.imgSrc = localStorage.getItem('localUrl') + '/static/admin_import.xlsx'
			this.actionUrl = localStorage.getItem('localUrl') + '/proapi/v1/project/upload'
		},
		methods: {
			showDialog(code) {
				this.innerVisible = true
				this.project_code = code
				setTimeout(() => {
					this.progecode = code
				})
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			onSuccess(response, file, fileList) {
				console.log('response', response)
				console.log('file', file)
				console.log('fileList', fileList)
				if (response.code != 200) {
					this.$message.error(response.msg)
				} else {
					this.$message({
						message: response.msg,
						type: 'success'
					});
					this.$emit('reFresh')
					this.fileName = file.name
					this.innerVisible = false
				}
			},
			closeImport() {
				this.innerVisible = false
			}
		}
	}
</script>

<style scoped="scoped">
	>>>.newdialog {
		border-radius: 6px;
	}

	>>>.el-dialog__body {
		padding: 20px 20px 10px 20px;
	}

	.innerdialog_list {
		display: flex;
		height: 40px;
		align-items: center;
		line-height: 40px;
		justify-content: space-between;
		margin-bottom: 10px;
		border-bottom: 1px solid #B5B5B5;
	}

	.innerdialog_list p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
	}

	.specilSpan {
		width: 30px;
		margin-left: 40px;
		height: 20px;
		line-height: 20px;
		background: #FFFFFF;
		text-align: center;
		border: 1px solid #1890FF;
	}

	.innerdialog_list span {
		font-size: 12px;
		font-weight: 400;
		color: #1890FF;
		cursor: pointer;
		font-family: PingFangSC-Regular, PingFang SC;
	}

	.innerdialog_list:first-child span {
		text-align: right;
		width: 70px;
	}

	/* .innerdialog_list:last-child span { */
	.innerspan {
		width: 30px;
		margin-left: 10px;
		height: 20px;
		line-height: 20px;
		background: #FFFFFF;
		text-align: center;
		border: 1px solid #1890FF;
	}

	>>>.el-upload-list {
		display: none;
	}

	>>>.el-upload {
		width: 50px;
	}
</style>
